import { Portal } from '../Portal/Portal';
import { useTranslation } from 'react-i18next';
import whiteCheckmark from '../../assets/icons/white-checkmark.svg';
import './BookingConfirmation.scss';

interface BookingConfirmationProps {
  onClose: () => void;
}

export const BookingConfirmation: React.FC<BookingConfirmationProps> = ({ onClose }) => {
  const { t } = useTranslation('events');

  return (
    <Portal>
      <div className="booking-confirmation__overlay">
        <div className="booking-confirmation">
          <div className="booking-confirmation__icon">
            <img src={whiteCheckmark} alt="Success" />
          </div>
          <h2 className="booking-confirmation__title">
            {t('bookingConfirmation.title')}
          </h2>
          <p className="booking-confirmation__message">
            {t('bookingConfirmation.message')}
          </p>
          <button className="booking-confirmation__close" onClick={onClose}>
            ×
          </button>
        </div>
      </div>
    </Portal>
  );
};
